export enum NavigationArea {
  TOP_SIDEBAR = 'topSidebar',
  BOTTOM_SIDEBAR = 'bottomSidebar',
  RIGHT_MENU = 'rightMenu',
  BOTTOM_NATIVE_BAR = 'bottomNativeBar'
}
